import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { Information} from "./information";
import {UrlBuilder} from "../url-builder/url.builder";

@Injectable({
  providedIn: 'root'
})
export class InformationDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<Information> {
    this.uiUrl = this.url.GetInformationUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<Information>(this.uiUrl);
  }


}

